export const MainCaroselData=[
    
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/6.jpg?v=1755190444&width=1880"
    },
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/8.jpg?v=1755414645&width=1880"
    },
  
    
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/2_99561f30-45b5-4401-aa04-9d979c61d32d.jpg?v=1762104598&width=1880",
        
    },
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/1_99fd8226-0466-4e7f-9914-64fcfaac5216.jpg?v=1762104598&width=1880",
        
    },
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/new1_2.jpg?v=1761889031&width=1880",
        
    },
    {
        image:"https://www.ethnicplus.in/cdn/shop/files/3_ea3e9279-2114-4e9e-8d23-6085ce1a143c.jpg?v=1762104598&width=1880",
        
    }

]
